// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,ts_nocheck
// @generated from protobuf file "agency/hook/v1/hook.proto" (package "agency.hook.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Duration } from "../../../google/protobuf/duration";
import { Permission } from "../../auth/v1/auth";
import { RBACRole } from "../../auth/v1/auth";
import { Timestamp } from "../../../google/protobuf/timestamp";
import { Any } from "../../../google/protobuf/any";
/**
 * HookEvent is the input to a hook execution.
 *
 * @generated from protobuf message agency.hook.v1.HookEvent
 */
export interface HookEvent {
    /**
     * hook_id uniquely identifies this hook invocation.
     *
     * @generated from protobuf field: string hook_id = 1
     */
    hookId: string;
    /**
     * point is the lifecycle point where the hook executes.
     *
     * @generated from protobuf field: agency.hook.v1.HookPoint point = 2
     */
    point: HookPoint;
    /**
     * data is the hook-specific payload.
     *
     * @generated from protobuf field: google.protobuf.Any data = 3
     */
    data?: Any;
    /**
     * tenant is the tenant context.
     *
     * @generated from protobuf field: string tenant = 4
     */
    tenant: string;
    /**
     * workspace is the workspace context.
     *
     * @generated from protobuf field: string workspace = 5
     */
    workspace: string;
    /**
     * session_id is the session context (if applicable).
     *
     * @generated from protobuf field: string session_id = 6
     */
    sessionId: string;
    /**
     * trace_id links to distributed trace.
     *
     * @generated from protobuf field: string trace_id = 7
     */
    traceId: string;
    /**
     * timestamp is when the hook was invoked.
     *
     * @generated from protobuf field: google.protobuf.Timestamp timestamp = 8
     */
    timestamp?: Timestamp;
    /**
     * metadata contains additional hook context.
     *
     * @generated from protobuf field: map<string, string> metadata = 9
     */
    metadata: {
        [key: string]: string;
    };
    /**
     * user_sub is the Casdoor user subject from validated Claims.
     *
     * @generated from protobuf field: string user_sub = 10
     */
    userSub: string;
    /**
     * roles are the RBAC roles from the session's Claims.
     *
     * @generated from protobuf field: repeated agency.auth.v1.RBACRole roles = 11
     */
    roles: RBACRole[];
    /**
     * permissions are the permissions from the session's Claims.
     *
     * @generated from protobuf field: repeated agency.auth.v1.Permission permissions = 12
     */
    permissions: Permission[];
    /**
     * trace_context is the W3C traceparent header value.
     *
     * @generated from protobuf field: string trace_context = 13
     */
    traceContext: string;
}
/**
 * HookResult is the output of a hook execution.
 *
 * @generated from protobuf message agency.hook.v1.HookResult
 */
export interface HookResult {
    /**
     * hook_id matches the HookEvent hook_id.
     *
     * @generated from protobuf field: string hook_id = 1
     */
    hookId: string;
    /**
     * reason explains a DENIED decision. Required when outcome=DENIED.
     *
     * @generated from protobuf field: string reason = 3
     */
    reason: string;
    /**
     * modified_data contains transformed data (if applicable).
     *
     * @generated from protobuf field: google.protobuf.Any modified_data = 4
     */
    modifiedData?: Any;
    /**
     * completed_at is when the hook completed.
     *
     * @generated from protobuf field: google.protobuf.Timestamp completed_at = 5
     */
    completedAt?: Timestamp;
    /**
     * execution_time_ms is the hook execution duration.
     *
     * @generated from protobuf field: int64 execution_time_ms = 6
     */
    executionTimeMs: bigint;
    /**
     * warnings are non-fatal issues detected by the hook.
     *
     * @generated from protobuf field: repeated string warnings = 7
     */
    warnings: string[];
    /**
     * metadata contains additional result context.
     *
     * @generated from protobuf field: map<string, string> metadata = 8
     */
    metadata: {
        [key: string]: string;
    };
    /**
     * outcome is the hook decision. Replaces the removed `approved` bool.
     * APPROVED: proceed. DENIED: stop, reason required.
     * STEERED: stop + inject steering message, new turn triggered.
     *
     * @generated from protobuf field: agency.hook.v1.HITLOutcome outcome = 9
     */
    outcome: HITLOutcome;
    /**
     * steering_scope controls how the steering message is injected.
     * Only meaningful when outcome=STEERED.
     *
     * @generated from protobuf field: agency.hook.v1.HITLSteeringScope steering_scope = 10
     */
    steeringScope: HITLSteeringScope;
    /**
     * steering is the message to inject when outcome=STEERED.
     * Required when outcome=STEERED. The LLM sees this and decides next steps;
     * the original operation is always rejected regardless of content.
     *
     * @generated from protobuf field: string steering = 11
     */
    steering: string;
    /**
     * replacement_args is a JSON object string supplying replacement tool arguments.
     * Only meaningful when outcome=APPROVED and point=PRE_TOOL_CALL.
     * When non-empty, the harness dispatches the tool with these args instead of the original.
     *
     * @generated from protobuf field: string replacement_args = 12
     */
    replacementArgs: string;
}
/**
 * RBACFilter matches sessions by RBAC roles or permissions.
 * OR within each list; AND across non-empty lists. Empty = always matches.
 *
 * @generated from protobuf message agency.hook.v1.RBACFilter
 */
export interface RBACFilter {
    /**
     * required_roles: at least one must match (OR). Empty = no role constraint.
     *
     * @generated from protobuf field: repeated agency.auth.v1.RBACRole required_roles = 1
     */
    requiredRoles: RBACRole[];
    /**
     * required_permissions: at least one must match (OR). Empty = no permission constraint.
     *
     * @generated from protobuf field: repeated agency.auth.v1.Permission required_permissions = 2
     */
    requiredPermissions: Permission[];
}
/**
 * ToolNameFilter is a (name, location) predicate for ToolFilter.
 * name: exact tool name — required, must satisfy tool name pattern.
 * location: provider location label — optional; empty = match any location.
 * Matching is case-insensitive on both fields.
 *
 * @generated from protobuf message agency.hook.v1.ToolNameFilter
 */
export interface ToolNameFilter {
    /**
     * name is the tool name to match (case-insensitive, required).
     *
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * location is the provider location label to match (case-insensitive).
     * Empty = match any location for this tool name.
     *
     * @generated from protobuf field: string location = 2
     */
    location: string;
}
/**
 * ToolFilter matches hook dispatch by tool (name, location) pair.
 * Applies only at PRE_TOOL_CALL and POST_TOOL_CALL hook points.
 * At all other hook points a ToolFilter evaluates to false (hook skipped) —
 * registering a ToolFilter on a non-tool point is a misconfiguration.
 *
 * OR semantics: hook fires if the tool call matches any entry.
 * Empty tools list = hook fires for all tools at all locations.
 *
 * @generated from protobuf message agency.hook.v1.ToolFilter
 */
export interface ToolFilter {
    /**
     * tools is the allowlist of (name, location) pairs (OR semantics).
     * Empty = all tools at all locations.
     *
     * @generated from protobuf field: repeated agency.hook.v1.ToolNameFilter tools = 1
     */
    tools: ToolNameFilter[];
}
/**
 * SessionFilter gates hook execution by session properties.
 * Multiple SessionFilters on a HookConfig are AND-ed together.
 *
 * @generated from protobuf message agency.hook.v1.SessionFilter
 */
export interface SessionFilter {
    /**
     * predicate is the filter condition (exactly one must be set).
     *
     * @generated from protobuf oneof: predicate
     */
    predicate: {
        oneofKind: "rbac";
        /**
         * rbac filters by role or permission.
         *
         * @generated from protobuf field: agency.hook.v1.RBACFilter rbac = 1
         */
        rbac: RBACFilter;
    } | {
        oneofKind: "tool";
        /**
         * tool filters by tool name (PRE_TOOL_CALL / POST_TOOL_CALL only).
         * At any other hook point, this filter evaluates to false (hook skipped).
         *
         * @generated from protobuf field: agency.hook.v1.ToolFilter tool = 2
         */
        tool: ToolFilter;
    } | {
        oneofKind: undefined;
    };
}
/**
 * HITLConfig defines human-in-the-loop approval requirements for a hook.
 * When present and enabled, the dispatcher pauses before executing the hook
 * and publishes a HITLRequestEvent, awaiting human approval.
 *
 * @generated from protobuf message agency.hook.v1.HITLConfig
 */
export interface HITLConfig {
    /**
     * enabled indicates if HITL approval is required.
     *
     * @generated from protobuf field: bool enabled = 1
     */
    enabled: boolean;
    /**
     * on_timeout_policy controls behaviour when approval is not received in time.
     *
     * @generated from protobuf field: agency.hook.v1.HITLOnTimeoutPolicy on_timeout_policy = 2
     */
    onTimeoutPolicy: HITLOnTimeoutPolicy;
    /**
     * gating_scope controls how much of the session is suspended.
     *
     * @generated from protobuf field: agency.hook.v1.HITLGatingScope gating_scope = 4
     */
    gatingScope: HITLGatingScope;
    /**
     * timeout is how long to wait for human approval.
     *
     * @generated from protobuf field: google.protobuf.Duration timeout = 5
     */
    timeout?: Duration;
    /**
     * steering_scope controls how a STEERED response injects the message.
     * Defaults to TURN (user-role message, current turn only).
     *
     * @generated from protobuf field: agency.hook.v1.HITLSteeringScope steering_scope = 6
     */
    steeringScope: HITLSteeringScope;
}
/**
 * HookConfig defines a hook's registration configuration.
 *
 * @generated from protobuf message agency.hook.v1.HookConfig
 */
export interface HookConfig {
    /**
     * hook_name uniquely identifies this hook.
     *
     * @generated from protobuf field: string hook_name = 1
     */
    hookName: string;
    /**
     * priority determines execution order (higher = earlier).
     *
     * @generated from protobuf field: int32 priority = 3
     */
    priority: number;
    /**
     * timeout_policy defines timeout handling.
     *
     * @generated from protobuf field: agency.hook.v1.HookTimeoutPolicy timeout_policy = 4
     */
    timeoutPolicy: HookTimeoutPolicy;
    /**
     * enabled indicates if the hook is active.
     *
     * @generated from protobuf field: bool enabled = 7
     */
    enabled: boolean;
    /**
     * tenant_filter restricts the hook to specific tenants (empty = all).
     *
     * @generated from protobuf field: repeated string tenant_filter = 8
     */
    tenantFilter: string[];
    /**
     * workspace_filter restricts the hook to specific workspaces (empty = all).
     *
     * @generated from protobuf field: repeated string workspace_filter = 9
     */
    workspaceFilter: string[];
    /**
     * description explains what the hook does.
     *
     * @generated from protobuf field: string description = 10
     */
    description: string;
    /**
     * subject is the harness-constructed canonical dispatch subject for this hook.
     * Set by the harness at registration time — not provider-declared.
     * Format: hook.<tenant>.<workspace>.<location>.<pid>.<hook_name>[.<session_id>]
     * Populated in HookRegistrationAck.dispatch_subject and stored here for RemoteHook dispatch.
     *
     * @generated from protobuf field: string subject = 11
     */
    subject: string;
    /**
     * timeout is the per-hook execution deadline. Required — no global fallback.
     *
     * @generated from protobuf field: google.protobuf.Duration timeout = 12
     */
    timeout?: Duration;
    /**
     * delivery_mode controls how hook requests are dispatched.
     *
     * @generated from protobuf field: agency.hook.v1.HookDeliveryMode delivery_mode = 13
     */
    deliveryMode: HookDeliveryMode;
    /**
     * session_filters are AND-ed; empty = hook always fires.
     *
     * @generated from protobuf field: repeated agency.hook.v1.SessionFilter session_filters = 14
     */
    sessionFilters: SessionFilter[];
    /**
     * hitl_config configures human-in-the-loop approval. Absent = no HITL.
     *
     * @generated from protobuf field: agency.hook.v1.HITLConfig hitl_config = 15
     */
    hitlConfig?: HITLConfig;
    /**
     * points lists all HookPoints where this hook executes (at least one).
     *
     * @generated from protobuf field: repeated agency.hook.v1.HookPoint points = 16
     */
    points: HookPoint[];
    /**
     * name is an alias populated by the KV registry on reads. Use hook_name for writes.
     *
     * @generated from protobuf field: string name = 17
     */
    name: string;
    /**
     * location is the hook provider's free-form location label.
     * Used for location-aware KV keying and duplicate policy at (hook_name, location).
     * Must satisfy [a-z0-9][a-z0-9_-]*[a-z0-9].
     *
     * @generated from protobuf field: string location = 18
     */
    location: string;
}
/**
 * HookTimeoutEvent signals hook execution timeout.
 *
 * @generated from protobuf message agency.hook.v1.HookTimeoutEvent
 */
export interface HookTimeoutEvent {
    /**
     * hook_name identifies the timed-out hook.
     *
     * @generated from protobuf field: string hook_name = 1
     */
    hookName: string;
    /**
     * point is the hook point.
     *
     * @generated from protobuf field: agency.hook.v1.HookPoint point = 2
     */
    point: HookPoint;
    /**
     * timeout_policy is the policy that was applied.
     *
     * @generated from protobuf field: agency.hook.v1.HookTimeoutPolicy timeout_policy = 3
     */
    timeoutPolicy: HookTimeoutPolicy;
    /**
     * timeout_duration_ms is the configured timeout.
     *
     * @generated from protobuf field: int64 timeout_duration_ms = 4
     */
    timeoutDurationMs: bigint;
    /**
     * occurred_at is when the timeout occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp occurred_at = 5
     */
    occurredAt?: Timestamp;
    /**
     * tenant is the tenant context.
     *
     * @generated from protobuf field: string tenant = 6
     */
    tenant: string;
    /**
     * workspace is the workspace context.
     *
     * @generated from protobuf field: string workspace = 7
     */
    workspace: string;
    /**
     * session_id is the session context (if applicable).
     *
     * @generated from protobuf field: string session_id = 8
     */
    sessionId: string;
}
/**
 * HookErrorEvent signals hook execution errors.
 *
 * @generated from protobuf message agency.hook.v1.HookErrorEvent
 */
export interface HookErrorEvent {
    /**
     * hook_name identifies the failed hook.
     *
     * @generated from protobuf field: string hook_name = 1
     */
    hookName: string;
    /**
     * point is the hook point.
     *
     * @generated from protobuf field: agency.hook.v1.HookPoint point = 2
     */
    point: HookPoint;
    /**
     * error_message describes the failure.
     *
     * @generated from protobuf field: string error_message = 3
     */
    errorMessage: string;
    /**
     * stack_trace provides debugging information.
     *
     * @generated from protobuf field: string stack_trace = 4
     */
    stackTrace: string;
    /**
     * occurred_at is when the error occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp occurred_at = 5
     */
    occurredAt?: Timestamp;
    /**
     * tenant is the tenant context.
     *
     * @generated from protobuf field: string tenant = 6
     */
    tenant: string;
    /**
     * workspace is the workspace context.
     *
     * @generated from protobuf field: string workspace = 7
     */
    workspace: string;
    /**
     * session_id is the session context (if applicable).
     *
     * @generated from protobuf field: string session_id = 8
     */
    sessionId: string;
    /**
     * panic_recovered indicates if this was a recovered panic.
     *
     * @generated from protobuf field: bool panic_recovered = 9
     */
    panicRecovered: boolean;
}
/**
 * SanitizationRule defines a single sanitization check.
 *
 * @generated from protobuf message agency.hook.v1.SanitizationRule
 */
export interface SanitizationRule {
    /**
     * rule_type is the type of sanitization check.
     *
     * @generated from protobuf field: agency.hook.v1.SanitizationRuleType rule_type = 1
     */
    ruleType: SanitizationRuleType;
    /**
     * field_path is the field to sanitize (JSONPath syntax, e.g., "$.args.filename").
     *
     * @generated from protobuf field: string field_path = 2
     */
    fieldPath: string;
    /**
     * pattern is the regex pattern (for REGEX_PATTERN type).
     *
     * @generated from protobuf field: string pattern = 3
     */
    pattern: string;
    /**
     * allowed_values are permitted values (for ALLOWLIST type).
     *
     * @generated from protobuf field: repeated string allowed_values = 4
     */
    allowedValues: string[];
    /**
     * denied_values are rejected values (for DENYLIST type).
     *
     * @generated from protobuf field: repeated string denied_values = 5
     */
    deniedValues: string[];
    /**
     * max_length is the maximum field length (for LENGTH_LIMIT type).
     *
     * @generated from protobuf field: int32 max_length = 6
     */
    maxLength: number;
    /**
     * enabled indicates if this rule is active.
     *
     * @generated from protobuf field: bool enabled = 7
     */
    enabled: boolean;
    /**
     * description explains what the rule checks.
     *
     * @generated from protobuf field: string description = 8
     */
    description: string;
    /**
     * severity indicates rule severity (INFO, WARN, ERROR, CRITICAL).
     *
     * @generated from protobuf field: string severity = 9
     */
    severity: string;
}
/**
 * ToolSanitizationConfig defines sanitization rules for tool execution.
 *
 * @generated from protobuf message agency.hook.v1.ToolSanitizationConfig
 */
export interface ToolSanitizationConfig {
    /**
     * tool_name is the tool this config applies to (empty = global default).
     *
     * @generated from protobuf field: string tool_name = 1
     */
    toolName: string;
    /**
     * input_rules are applied to PRE_TOOL_CALL hook (SecurityGateActor input path).
     *
     * @generated from protobuf field: repeated agency.hook.v1.SanitizationRule input_rules = 2
     */
    inputRules: SanitizationRule[];
    /**
     * output_rules are applied to POST_TOOL_CALL hook (SecurityGateActor output path).
     *
     * @generated from protobuf field: repeated agency.hook.v1.SanitizationRule output_rules = 3
     */
    outputRules: SanitizationRule[];
    /**
     * abort_on_violation determines if violations abort execution.
     *
     * @generated from protobuf field: bool abort_on_violation = 4
     */
    abortOnViolation: boolean;
    /**
     * log_violations indicates if violations should be logged.
     *
     * @generated from protobuf field: bool log_violations = 5
     */
    logViolations: boolean;
    /**
     * enabled indicates if this config is active.
     *
     * @generated from protobuf field: bool enabled = 6
     */
    enabled: boolean;
    /**
     * tenant_scope restricts config to specific tenant (empty = global).
     *
     * @generated from protobuf field: string tenant_scope = 7
     */
    tenantScope: string;
    /**
     * workspace_scope restricts config to specific workspace (empty = tenant-wide).
     *
     * @generated from protobuf field: string workspace_scope = 8
     */
    workspaceScope: string;
}
/**
 * HookRegistrationRequest registers a hook at runtime.
 *
 * @generated from protobuf message agency.hook.v1.HookRegistrationRequest
 */
export interface HookRegistrationRequest {
    /**
     * config is the hook configuration.
     *
     * @generated from protobuf field: agency.hook.v1.HookConfig config = 1
     */
    config?: HookConfig;
    /**
     * handler_endpoint is the hook execution endpoint (NATS subject or HTTP URL).
     *
     * @generated from protobuf field: string handler_endpoint = 2
     */
    handlerEndpoint: string;
    /**
     * handler_type indicates how to invoke the hook.
     *
     * @generated from protobuf field: agency.hook.v1.HookHandlerType handler_type = 3
     */
    handlerType: HookHandlerType;
    /**
     * registered_by identifies who registered this hook (user, system, extension).
     *
     * @generated from protobuf field: string registered_by = 4
     */
    registeredBy: string;
}
/**
 * HookRegistrationResponse confirms hook registration.
 *
 * @generated from protobuf message agency.hook.v1.HookRegistrationResponse
 */
export interface HookRegistrationResponse {
    /**
     * hook_name is the registered hook identifier.
     *
     * @generated from protobuf field: string hook_name = 1
     */
    hookName: string;
    /**
     * registered_at is when the hook was registered.
     *
     * @generated from protobuf field: google.protobuf.Timestamp registered_at = 2
     */
    registeredAt?: Timestamp;
    /**
     * handler_endpoint is the hook execution endpoint.
     *
     * @generated from protobuf field: string handler_endpoint = 3
     */
    handlerEndpoint: string;
}
/**
 * HookDeregistrationRequest removes a registered hook.
 *
 * @generated from protobuf message agency.hook.v1.HookDeregistrationRequest
 */
export interface HookDeregistrationRequest {
    /**
     * hook_name is the hook to remove.
     *
     * @generated from protobuf field: string hook_name = 1
     */
    hookName: string;
    /**
     * reason explains why the hook is being removed.
     *
     * @generated from protobuf field: string reason = 2
     */
    reason: string;
}
/**
 * HookDeregistrationResponse confirms hook removal.
 *
 * @generated from protobuf message agency.hook.v1.HookDeregistrationResponse
 */
export interface HookDeregistrationResponse {
    /**
     * hook_name is the removed hook identifier.
     *
     * @generated from protobuf field: string hook_name = 1
     */
    hookName: string;
    /**
     * deregistered_at is when the hook was removed.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deregistered_at = 2
     */
    deregisteredAt?: Timestamp;
}
/**
 * HookListRequest requests all registered hooks (optionally filtered).
 *
 * @generated from protobuf message agency.hook.v1.HookListRequest
 */
export interface HookListRequest {
    /**
     * point filters by lifecycle point (empty = all).
     *
     * @generated from protobuf field: agency.hook.v1.HookPoint point = 1
     */
    point: HookPoint;
    /**
     * tenant filters by tenant (empty = all).
     *
     * @generated from protobuf field: string tenant = 2
     */
    tenant: string;
    /**
     * workspace filters by workspace (empty = all).
     *
     * @generated from protobuf field: string workspace = 3
     */
    workspace: string;
    /**
     * enabled_only returns only enabled hooks.
     *
     * @generated from protobuf field: bool enabled_only = 4
     */
    enabledOnly: boolean;
}
/**
 * HookListResponse returns registered hooks.
 *
 * @generated from protobuf message agency.hook.v1.HookListResponse
 */
export interface HookListResponse {
    /**
     * hooks are the registered hooks matching the filter.
     *
     * @generated from protobuf field: repeated agency.hook.v1.HookConfig hooks = 1
     */
    hooks: HookConfig[];
    /**
     * total_count is the number of matching hooks.
     *
     * @generated from protobuf field: int32 total_count = 2
     */
    totalCount: number;
}
/**
 * HITLRequestEvent is published to hitl-requests_<t>_<w> when a hook requires
 * human approval. Subject: hitl.<tenant>.<workspace>.<session>.<point>.<hook_name>
 *
 * @generated from protobuf message agency.hook.v1.HITLRequestEvent
 */
export interface HITLRequestEvent {
    /**
     * hook_name identifies which hook requires approval.
     *
     * @generated from protobuf field: string hook_name = 1
     */
    hookName: string;
    /**
     * point is the lifecycle point where approval is needed.
     *
     * @generated from protobuf field: agency.hook.v1.HookPoint point = 2
     */
    point: HookPoint;
    /**
     * tenant is the tenant context.
     *
     * @generated from protobuf field: string tenant = 3
     */
    tenant: string;
    /**
     * workspace is the workspace context.
     *
     * @generated from protobuf field: string workspace = 4
     */
    workspace: string;
    /**
     * session_id identifies the session awaiting approval.
     *
     * @generated from protobuf field: string session_id = 5
     */
    sessionId: string;
    /**
     * user_sub is the user who initiated the action requiring approval.
     *
     * @generated from protobuf field: string user_sub = 6
     */
    userSub: string;
    /**
     * payload is the hook-specific data (ToolCall, ToolResult, etc.).
     *
     * @generated from protobuf field: google.protobuf.Any payload = 7
     */
    payload?: Any;
    /**
     * gating_scope is the suspension scope from HITLConfig.
     *
     * @generated from protobuf field: agency.hook.v1.HITLGatingScope gating_scope = 8
     */
    gatingScope: HITLGatingScope;
    /**
     * requested_at is when the HITL request was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp requested_at = 9
     */
    requestedAt?: Timestamp;
    /**
     * timeout is how long the approver has to respond.
     *
     * @generated from protobuf field: google.protobuf.Duration timeout = 10
     */
    timeout?: Duration;
    /**
     * hitl_id is a harness-generated UUID uniquely identifying this HITL gate instance.
     * Echoed in HITLResponseEvent to correlate response to request.
     * Enables multiple concurrent HITL gates for the same hook.
     *
     * @generated from protobuf field: string hitl_id = 11
     */
    hitlId: string;
    /**
     * deadline is the absolute instant the harness gate times out this request
     * (gate timer start + timeout). Authoritative for all consumers; re-set on escalation.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deadline = 12
     */
    deadline?: Timestamp;
    /**
     * on_timeout_policy is the gate's configured HITLConfig.on_timeout_policy.
     * Display-only for consumers — the harness gate applies it at deadline.
     *
     * @generated from protobuf field: agency.hook.v1.HITLOnTimeoutPolicy on_timeout_policy = 13
     */
    onTimeoutPolicy: HITLOnTimeoutPolicy;
}
/**
 * HITLResponseEvent is published to hitl-responses_<t>_<w> by approval services.
 * Subject: hitl.<tenant>.<workspace>.<session>.<point>.<hook_name>
 *
 * @generated from protobuf message agency.hook.v1.HITLResponseEvent
 */
export interface HITLResponseEvent {
    /**
     * hook_name identifies which hook was reviewed.
     *
     * @generated from protobuf field: string hook_name = 1
     */
    hookName: string;
    /**
     * session_id identifies the session that was suspended.
     *
     * @generated from protobuf field: string session_id = 2
     */
    sessionId: string;
    /**
     * outcome is the human decision.
     *
     * @generated from protobuf field: agency.hook.v1.HITLOutcome outcome = 3
     */
    outcome: HITLOutcome;
    /**
     * reason explains a DENIED decision. Required when outcome=DENIED.
     *
     * @generated from protobuf field: string reason = 4
     */
    reason: string;
    /**
     * steering is the message to inject when outcome=STEERED.
     * Required when outcome=STEERED. The LLM sees this and decides next steps;
     * the original operation is always rejected regardless of content.
     *
     * @generated from protobuf field: string steering = 5
     */
    steering: string;
    /**
     * replacement_args is a JSON object string supplying replacement tool arguments.
     * Only meaningful when outcome=APPROVED and point=PRE_TOOL_CALL.
     *
     * @generated from protobuf field: string replacement_args = 8
     */
    replacementArgs: string;
    /**
     * hitl_id correlates this response to the originating HITLRequestEvent.
     *
     * @generated from protobuf field: string hitl_id = 9
     */
    hitlId: string;
    /**
     * approver_sub is the identity of who responded.
     *
     * @generated from protobuf field: string approver_sub = 6
     */
    approverSub: string;
    /**
     * responded_at is when the decision was made.
     *
     * @generated from protobuf field: google.protobuf.Timestamp responded_at = 7
     */
    respondedAt?: Timestamp;
}
/**
 * HookRegistrationAck is returned by the harness on hook.register req/reply.
 *
 * @generated from protobuf message agency.hook.v1.HookRegistrationAck
 */
export interface HookRegistrationAck {
    /**
     * heartbeat_interval_seconds is the interval at which the provider must republish
     * the hook descriptor to refresh the KV TTL.
     *
     * @generated from protobuf field: int32 heartbeat_interval_seconds = 1
     */
    heartbeatIntervalSeconds: number;
    /**
     * dispatch_subject is the harness-constructed canonical NATS subject the provider
     * must subscribe to for this hook. Mirrors ExecutionSubject in ToolRegistrationAck.
     * Format: hook.<tenant>.<workspace>.<location>.<pid>.<hook_name>[.<session_id>]
     *
     * @generated from protobuf field: string dispatch_subject = 2
     */
    dispatchSubject: string;
}
/**
 * HookPoint defines where hooks execute in the system lifecycle.
 *
 * @generated from protobuf enum agency.hook.v1.HookPoint
 */
export enum HookPoint {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: HOOK_POINT_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * PRE_TOOL_CALL validates tool calls before execution (SECURITY-CRITICAL).
     *
     * @generated from protobuf enum value: HOOK_POINT_PRE_TOOL_CALL = 1;
     */
    PRE_TOOL_CALL = 1,
    /**
     * POST_TOOL_CALL sanitizes tool outputs (SECURITY-CRITICAL).
     *
     * @generated from protobuf enum value: HOOK_POINT_POST_TOOL_CALL = 2;
     */
    POST_TOOL_CALL = 2,
    /**
     * SESSION_START executes at session initialization.
     *
     * @generated from protobuf enum value: HOOK_POINT_SESSION_START = 3;
     */
    SESSION_START = 3,
    /**
     * SESSION_END executes at session completion.
     *
     * @generated from protobuf enum value: HOOK_POINT_SESSION_END = 4;
     */
    SESSION_END = 4,
    /**
     * HARNESS_START executes at harness startup.
     *
     * @generated from protobuf enum value: HOOK_POINT_HARNESS_START = 5;
     */
    HARNESS_START = 5,
    /**
     * PRE_LLM_CALL executes before LLM inference.
     *
     * @generated from protobuf enum value: HOOK_POINT_PRE_LLM_CALL = 6;
     */
    PRE_LLM_CALL = 6,
    /**
     * POST_LLM_CALL executes after LLM inference.
     *
     * @generated from protobuf enum value: HOOK_POINT_POST_LLM_CALL = 7;
     */
    POST_LLM_CALL = 7,
    /**
     * CONTEXT_UPDATED executes on context changes.
     *
     * @generated from protobuf enum value: HOOK_POINT_CONTEXT_UPDATED = 8;
     */
    CONTEXT_UPDATED = 8,
    /**
     * PRE_FEDERATION executes before cross-harness delegation.
     *
     * @generated from protobuf enum value: HOOK_POINT_PRE_FEDERATION = 9;
     */
    PRE_FEDERATION = 9,
    /**
     * POST_FEDERATION executes after cross-harness delegation.
     *
     * @generated from protobuf enum value: HOOK_POINT_POST_FEDERATION = 10;
     */
    POST_FEDERATION = 10,
    /**
     * TURN_START executes once at the beginning of a turn, before any LLM call.
     * Can block/steer the entire turn. Fires before PRE_LLM_CALL.
     *
     * @generated from protobuf enum value: HOOK_POINT_TURN_START = 11;
     */
    TURN_START = 11,
    /**
     * TURN_END executes once after all tool loops complete and the turn is done.
     * Observe-only: no gating semantics.
     *
     * @generated from protobuf enum value: HOOK_POINT_TURN_END = 12;
     */
    TURN_END = 12,
    /**
     * HARNESS_SHUTDOWN executes during harness graceful shutdown.
     * Observe-only: allows cleanup, drain notifications, external de-registration.
     *
     * @generated from protobuf enum value: HOOK_POINT_HARNESS_SHUTDOWN = 13;
     */
    HARNESS_SHUTDOWN = 13,
    /**
     * SESSION_FORK executes when a child session is forked from a parent.
     * Observe-only: fired after child SessionActor is spawned.
     * Payload: SessionForkedEvent (contains parent, child, thread, turn, seq).
     *
     * @generated from protobuf enum value: HOOK_POINT_SESSION_FORK = 14;
     */
    SESSION_FORK = 14,
    /**
     * CONCURRENT_INGRESS_MESSAGE fires when a new ingress message arrives while
     * an LLM turn is active (streaming). Gating hook: outcome controls message
     * disposition (enqueue, reject to DLQ, or steer active turn).
     * Payload: IngressEvent.
     *
     * @generated from protobuf enum value: HOOK_POINT_CONCURRENT_INGRESS_MESSAGE = 15;
     */
    CONCURRENT_INGRESS_MESSAGE = 15,
    /**
     * CONCURRENT_INGRESS_TOOL fires when a new ingress message arrives while
     * tool dispatch is active. Same gating semantics as CONCURRENT_INGRESS_MESSAGE.
     * Payload: IngressEvent.
     *
     * @generated from protobuf enum value: HOOK_POINT_CONCURRENT_INGRESS_TOOL = 16;
     */
    CONCURRENT_INGRESS_TOOL = 16
}
/**
 * HookTimeoutPolicy defines how timeouts are handled.
 *
 * @generated from protobuf enum agency.hook.v1.HookTimeoutPolicy
 */
export enum HookTimeoutPolicy {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: HOOK_TIMEOUT_POLICY_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * ABORT fails the operation on timeout (default for security hooks).
     *
     * @generated from protobuf enum value: HOOK_TIMEOUT_POLICY_ABORT = 1;
     */
    ABORT = 1,
    /**
     * SKIP_PROCEED logs timeout and continues with original data.
     *
     * @generated from protobuf enum value: HOOK_TIMEOUT_POLICY_SKIP_PROCEED = 2;
     */
    SKIP_PROCEED = 2
}
/**
 * HookDeliveryMode controls how hook requests are dispatched.
 * ABORT timeout_policy requires SYNC_REQUEST_REPLY.
 *
 * @generated from protobuf enum agency.hook.v1.HookDeliveryMode
 */
export enum HookDeliveryMode {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: HOOK_DELIVERY_MODE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * SYNC_REQUEST_REPLY blocks via NATS core req/reply. Required for ABORT policy.
     *
     * @generated from protobuf enum value: HOOK_DELIVERY_MODE_SYNC_REQUEST_REPLY = 1;
     */
    SYNC_REQUEST_REPLY = 1,
    /**
     * ASYNC_PUBLISH fires-and-forgets via NATS publish. For observability hooks.
     *
     * @generated from protobuf enum value: HOOK_DELIVERY_MODE_ASYNC_PUBLISH = 2;
     */
    ASYNC_PUBLISH = 2,
    /**
     * DURABLE_WORK_QUEUE publishes via JetStream. Durable, survives restarts. Required for HITL.
     *
     * @generated from protobuf enum value: HOOK_DELIVERY_MODE_DURABLE_WORK_QUEUE = 3;
     */
    DURABLE_WORK_QUEUE = 3
}
/**
 * HITLOnTimeoutPolicy defines behaviour when a HITL approval times out.
 *
 * @generated from protobuf enum agency.hook.v1.HITLOnTimeoutPolicy
 */
export enum HITLOnTimeoutPolicy {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: HITL_ON_TIMEOUT_POLICY_UNSPECIFIED = 0;
     */
    HITL_ON_TIMEOUT_POLICY_UNSPECIFIED = 0,
    /**
     * AUTO_DENY rejects the operation on timeout (safe default).
     *
     * @generated from protobuf enum value: HITL_ON_TIMEOUT_POLICY_AUTO_DENY = 1;
     */
    HITL_ON_TIMEOUT_POLICY_AUTO_DENY = 1,
    /**
     * AUTO_APPROVE proceeds as if approved on timeout.
     *
     * @generated from protobuf enum value: HITL_ON_TIMEOUT_POLICY_AUTO_APPROVE = 2;
     */
    HITL_ON_TIMEOUT_POLICY_AUTO_APPROVE = 2,
    /**
     * ESCALATE publishes to escalation_subject and awaits a second response.
     *
     * @generated from protobuf enum value: HITL_ON_TIMEOUT_POLICY_ESCALATE = 3;
     */
    HITL_ON_TIMEOUT_POLICY_ESCALATE = 3
}
/**
 * HITLGatingScope defines how much of the session is suspended during HITL.
 *
 * @generated from protobuf enum agency.hook.v1.HITLGatingScope
 */
export enum HITLGatingScope {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: HITL_GATING_SCOPE_UNSPECIFIED = 0;
     */
    HITL_GATING_SCOPE_UNSPECIFIED = 0,
    /**
     * SESSION suspends the entire session — no new ingress processed until resolved.
     *
     * @generated from protobuf enum value: HITL_GATING_SCOPE_SESSION = 1;
     */
    HITL_GATING_SCOPE_SESSION = 1,
    /**
     * TURN suspends only the current turn — new ingress enqueued behind gate.
     *
     * @generated from protobuf enum value: HITL_GATING_SCOPE_TURN = 2;
     */
    HITL_GATING_SCOPE_TURN = 2
}
/**
 * HITLOutcome is the human decision on a HITL request.
 *
 * @generated from protobuf enum agency.hook.v1.HITLOutcome
 */
export enum HITLOutcome {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: HITL_OUTCOME_UNSPECIFIED = 0;
     */
    HITL_OUTCOME_UNSPECIFIED = 0,
    /**
     * APPROVED allows the hook/operation to proceed as-is.
     *
     * @generated from protobuf enum value: HITL_OUTCOME_APPROVED = 1;
     */
    HITL_OUTCOME_APPROVED = 1,
    /**
     * DENIED rejects the operation. reason field is required.
     *
     * @generated from protobuf enum value: HITL_OUTCOME_DENIED = 2;
     */
    HITL_OUTCOME_DENIED = 2,
    /**
     * STEERED rejects the current operation and injects a steering message into
     * the session so the LLM can course-correct. The operation does NOT proceed.
     * steering field must be non-empty.
     *
     * @generated from protobuf enum value: HITL_OUTCOME_STEERED = 3;
     */
    HITL_OUTCOME_STEERED = 3,
    /**
     * ESCALATED forwards the pending HITL request to the configured escalation_subject
     * for a second approver. The session remains suspended.
     *
     * @generated from protobuf enum value: HITL_OUTCOME_ESCALATED = 4;
     */
    HITL_OUTCOME_ESCALATED = 4
}
/**
 * HITLSteeringScope controls how the steering message is injected.
 *
 * @generated from protobuf enum agency.hook.v1.HITLSteeringScope
 */
export enum HITLSteeringScope {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: HITL_STEERING_SCOPE_UNSPECIFIED = 0;
     */
    HITL_STEERING_SCOPE_UNSPECIFIED = 0,
    /**
     * TURN injects as a user-role message for the current turn only (default).
     *
     * @generated from protobuf enum value: HITL_STEERING_SCOPE_TURN = 1;
     */
    HITL_STEERING_SCOPE_TURN = 1,
    /**
     * SESSION prepends as a system-role message — permanent for the session lifetime.
     *
     * @generated from protobuf enum value: HITL_STEERING_SCOPE_SESSION = 2;
     */
    HITL_STEERING_SCOPE_SESSION = 2
}
/**
 * SanitizationRuleType defines the type of sanitization check.
 *
 * @generated from protobuf enum agency.hook.v1.SanitizationRuleType
 */
export enum SanitizationRuleType {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: SANITIZATION_RULE_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * PROMPT_INJECTION detects prompt injection attacks.
     *
     * @generated from protobuf enum value: SANITIZATION_RULE_TYPE_PROMPT_INJECTION = 1;
     */
    PROMPT_INJECTION = 1,
    /**
     * PATH_TRAVERSAL detects path traversal attempts (../, etc).
     *
     * @generated from protobuf enum value: SANITIZATION_RULE_TYPE_PATH_TRAVERSAL = 2;
     */
    PATH_TRAVERSAL = 2,
    /**
     * SHELL_METACHARACTERS detects shell command injection.
     *
     * @generated from protobuf enum value: SANITIZATION_RULE_TYPE_SHELL_METACHARACTERS = 3;
     */
    SHELL_METACHARACTERS = 3,
    /**
     * SQL_INJECTION detects SQL injection patterns.
     *
     * @generated from protobuf enum value: SANITIZATION_RULE_TYPE_SQL_INJECTION = 4;
     */
    SQL_INJECTION = 4,
    /**
     * XSS detects cross-site scripting patterns.
     *
     * @generated from protobuf enum value: SANITIZATION_RULE_TYPE_XSS = 5;
     */
    XSS = 5,
    /**
     * LENGTH_LIMIT enforces argument length bounds.
     *
     * @generated from protobuf enum value: SANITIZATION_RULE_TYPE_LENGTH_LIMIT = 6;
     */
    LENGTH_LIMIT = 6,
    /**
     * TYPE_COERCION validates type safety.
     *
     * @generated from protobuf enum value: SANITIZATION_RULE_TYPE_TYPE_COERCION = 7;
     */
    TYPE_COERCION = 7,
    /**
     * CREDENTIAL_EXPOSURE detects leaked credentials.
     *
     * @generated from protobuf enum value: SANITIZATION_RULE_TYPE_CREDENTIAL_EXPOSURE = 8;
     */
    CREDENTIAL_EXPOSURE = 8,
    /**
     * PII_EXPOSURE detects personally identifiable information.
     *
     * @generated from protobuf enum value: SANITIZATION_RULE_TYPE_PII_EXPOSURE = 9;
     */
    PII_EXPOSURE = 9,
    /**
     * REGEX_PATTERN applies custom regex pattern validation.
     *
     * @generated from protobuf enum value: SANITIZATION_RULE_TYPE_REGEX_PATTERN = 10;
     */
    REGEX_PATTERN = 10,
    /**
     * ALLOWLIST validates against allowed values.
     *
     * @generated from protobuf enum value: SANITIZATION_RULE_TYPE_ALLOWLIST = 11;
     */
    ALLOWLIST = 11,
    /**
     * DENYLIST rejects specific values.
     *
     * @generated from protobuf enum value: SANITIZATION_RULE_TYPE_DENYLIST = 12;
     */
    DENYLIST = 12
}
/**
 * HookHandlerType defines how hooks are invoked.
 *
 * @generated from protobuf enum agency.hook.v1.HookHandlerType
 */
export enum HookHandlerType {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: HOOK_HANDLER_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * NATS_REQUEST invokes via NATS request/reply.
     *
     * @generated from protobuf enum value: HOOK_HANDLER_TYPE_NATS_REQUEST = 1;
     */
    NATS_REQUEST = 1,
    /**
     * HTTP_POST invokes via HTTP POST.
     *
     * @generated from protobuf enum value: HOOK_HANDLER_TYPE_HTTP_POST = 2;
     */
    HTTP_POST = 2,
    /**
     * IN_PROCESS invokes via registered Go function (internal only).
     *
     * @generated from protobuf enum value: HOOK_HANDLER_TYPE_IN_PROCESS = 3;
     */
    IN_PROCESS = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class HookEvent$Type extends MessageType<HookEvent> {
    constructor() {
        super("agency.hook.v1.HookEvent", [
            { no: 1, name: "hook_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "point", kind: "enum", T: () => ["agency.hook.v1.HookPoint", HookPoint, "HOOK_POINT_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 3, name: "data", kind: "message", T: () => Any, options: { "buf.validate.field": { required: true } } },
            { no: 4, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 5, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 6, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 7, name: "trace_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { pattern: "^([0-9a-f]{32})?$" } } } },
            { no: 8, name: "timestamp", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 9, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "20", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "2048" } } } } } },
            { no: 10, name: "user_sub", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "256" } } } },
            { no: 11, name: "roles", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["agency.auth.v1.RBACRole", RBACRole], options: { "buf.validate.field": { repeated: { maxItems: "10" } } } },
            { no: 12, name: "permissions", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["agency.auth.v1.Permission", Permission, "PERMISSION_"], options: { "buf.validate.field": { repeated: { maxItems: "20" } } } },
            { no: 13, name: "trace_context", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "512" } } } }
        ]);
    }
    create(value?: PartialMessage<HookEvent>): HookEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.hookId = "";
        message.point = 0;
        message.tenant = "";
        message.workspace = "";
        message.sessionId = "";
        message.traceId = "";
        message.metadata = {};
        message.userSub = "";
        message.roles = [];
        message.permissions = [];
        message.traceContext = "";
        if (value !== undefined)
            reflectionMergePartial<HookEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: HookEvent): HookEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string hook_id */ 1:
                    message.hookId = reader.string();
                    break;
                case /* agency.hook.v1.HookPoint point */ 2:
                    message.point = reader.int32();
                    break;
                case /* google.protobuf.Any data */ 3:
                    message.data = Any.internalBinaryRead(reader, reader.uint32(), options, message.data);
                    break;
                case /* string tenant */ 4:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 5:
                    message.workspace = reader.string();
                    break;
                case /* string session_id */ 6:
                    message.sessionId = reader.string();
                    break;
                case /* string trace_id */ 7:
                    message.traceId = reader.string();
                    break;
                case /* google.protobuf.Timestamp timestamp */ 8:
                    message.timestamp = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.timestamp);
                    break;
                case /* map<string, string> metadata */ 9:
                    this.binaryReadMap9(message.metadata, reader, options);
                    break;
                case /* string user_sub */ 10:
                    message.userSub = reader.string();
                    break;
                case /* repeated agency.auth.v1.RBACRole roles */ 11:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.roles.push(reader.int32());
                    else
                        message.roles.push(reader.int32());
                    break;
                case /* repeated agency.auth.v1.Permission permissions */ 12:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.permissions.push(reader.int32());
                    else
                        message.permissions.push(reader.int32());
                    break;
                case /* string trace_context */ 13:
                    message.traceContext = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap9(map: HookEvent["metadata"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof HookEvent["metadata"] | undefined, val: HookEvent["metadata"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.hook.v1.HookEvent.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: HookEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string hook_id = 1; */
        if (message.hookId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.hookId);
        /* agency.hook.v1.HookPoint point = 2; */
        if (message.point !== 0)
            writer.tag(2, WireType.Varint).int32(message.point);
        /* google.protobuf.Any data = 3; */
        if (message.data)
            Any.internalBinaryWrite(message.data, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string tenant = 4; */
        if (message.tenant !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 5; */
        if (message.workspace !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.workspace);
        /* string session_id = 6; */
        if (message.sessionId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.sessionId);
        /* string trace_id = 7; */
        if (message.traceId !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.traceId);
        /* google.protobuf.Timestamp timestamp = 8; */
        if (message.timestamp)
            Timestamp.internalBinaryWrite(message.timestamp, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* map<string, string> metadata = 9; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(9, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        /* string user_sub = 10; */
        if (message.userSub !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.userSub);
        /* repeated agency.auth.v1.RBACRole roles = 11; */
        if (message.roles.length) {
            writer.tag(11, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.roles.length; i++)
                writer.int32(message.roles[i]);
            writer.join();
        }
        /* repeated agency.auth.v1.Permission permissions = 12; */
        if (message.permissions.length) {
            writer.tag(12, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.permissions.length; i++)
                writer.int32(message.permissions[i]);
            writer.join();
        }
        /* string trace_context = 13; */
        if (message.traceContext !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.traceContext);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.hook.v1.HookEvent
 */
export const HookEvent = new HookEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HookResult$Type extends MessageType<HookResult> {
    constructor() {
        super("agency.hook.v1.HookResult", [
            { no: 1, name: "hook_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "2048" } } } },
            { no: 4, name: "modified_data", kind: "message", T: () => Any },
            { no: 5, name: "completed_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 6, name: "execution_time_ms", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } },
            { no: 7, name: "warnings", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "20", items: { string: { minLen: "1", maxLen: "1024" } } } } } },
            { no: 8, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "20", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "2048" } } } } } },
            { no: 9, name: "outcome", kind: "enum", T: () => ["agency.hook.v1.HITLOutcome", HITLOutcome], options: { "buf.validate.field": { enum: { definedOnly: true } } } },
            { no: 10, name: "steering_scope", kind: "enum", T: () => ["agency.hook.v1.HITLSteeringScope", HITLSteeringScope], options: { "buf.validate.field": { enum: { definedOnly: true } } } },
            { no: 11, name: "steering", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "4096" } } } },
            { no: 12, name: "replacement_args", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "65536" } } } }
        ]);
    }
    create(value?: PartialMessage<HookResult>): HookResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.hookId = "";
        message.reason = "";
        message.executionTimeMs = 0n;
        message.warnings = [];
        message.metadata = {};
        message.outcome = 0;
        message.steeringScope = 0;
        message.steering = "";
        message.replacementArgs = "";
        if (value !== undefined)
            reflectionMergePartial<HookResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: HookResult): HookResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string hook_id */ 1:
                    message.hookId = reader.string();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* google.protobuf.Any modified_data */ 4:
                    message.modifiedData = Any.internalBinaryRead(reader, reader.uint32(), options, message.modifiedData);
                    break;
                case /* google.protobuf.Timestamp completed_at */ 5:
                    message.completedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.completedAt);
                    break;
                case /* int64 execution_time_ms */ 6:
                    message.executionTimeMs = reader.int64().toBigInt();
                    break;
                case /* repeated string warnings */ 7:
                    message.warnings.push(reader.string());
                    break;
                case /* map<string, string> metadata */ 8:
                    this.binaryReadMap8(message.metadata, reader, options);
                    break;
                case /* agency.hook.v1.HITLOutcome outcome */ 9:
                    message.outcome = reader.int32();
                    break;
                case /* agency.hook.v1.HITLSteeringScope steering_scope */ 10:
                    message.steeringScope = reader.int32();
                    break;
                case /* string steering */ 11:
                    message.steering = reader.string();
                    break;
                case /* string replacement_args */ 12:
                    message.replacementArgs = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap8(map: HookResult["metadata"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof HookResult["metadata"] | undefined, val: HookResult["metadata"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.hook.v1.HookResult.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: HookResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string hook_id = 1; */
        if (message.hookId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.hookId);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* google.protobuf.Any modified_data = 4; */
        if (message.modifiedData)
            Any.internalBinaryWrite(message.modifiedData, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp completed_at = 5; */
        if (message.completedAt)
            Timestamp.internalBinaryWrite(message.completedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* int64 execution_time_ms = 6; */
        if (message.executionTimeMs !== 0n)
            writer.tag(6, WireType.Varint).int64(message.executionTimeMs);
        /* repeated string warnings = 7; */
        for (let i = 0; i < message.warnings.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.warnings[i]);
        /* map<string, string> metadata = 8; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(8, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        /* agency.hook.v1.HITLOutcome outcome = 9; */
        if (message.outcome !== 0)
            writer.tag(9, WireType.Varint).int32(message.outcome);
        /* agency.hook.v1.HITLSteeringScope steering_scope = 10; */
        if (message.steeringScope !== 0)
            writer.tag(10, WireType.Varint).int32(message.steeringScope);
        /* string steering = 11; */
        if (message.steering !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.steering);
        /* string replacement_args = 12; */
        if (message.replacementArgs !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.replacementArgs);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.hook.v1.HookResult
 */
export const HookResult = new HookResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RBACFilter$Type extends MessageType<RBACFilter> {
    constructor() {
        super("agency.hook.v1.RBACFilter", [
            { no: 1, name: "required_roles", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["agency.auth.v1.RBACRole", RBACRole], options: { "buf.validate.field": { repeated: { maxItems: "10" } } } },
            { no: 2, name: "required_permissions", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["agency.auth.v1.Permission", Permission, "PERMISSION_"], options: { "buf.validate.field": { repeated: { maxItems: "20" } } } }
        ]);
    }
    create(value?: PartialMessage<RBACFilter>): RBACFilter {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.requiredRoles = [];
        message.requiredPermissions = [];
        if (value !== undefined)
            reflectionMergePartial<RBACFilter>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RBACFilter): RBACFilter {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated agency.auth.v1.RBACRole required_roles */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.requiredRoles.push(reader.int32());
                    else
                        message.requiredRoles.push(reader.int32());
                    break;
                case /* repeated agency.auth.v1.Permission required_permissions */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.requiredPermissions.push(reader.int32());
                    else
                        message.requiredPermissions.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RBACFilter, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated agency.auth.v1.RBACRole required_roles = 1; */
        if (message.requiredRoles.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.requiredRoles.length; i++)
                writer.int32(message.requiredRoles[i]);
            writer.join();
        }
        /* repeated agency.auth.v1.Permission required_permissions = 2; */
        if (message.requiredPermissions.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.requiredPermissions.length; i++)
                writer.int32(message.requiredPermissions[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.hook.v1.RBACFilter
 */
export const RBACFilter = new RBACFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ToolNameFilter$Type extends MessageType<ToolNameFilter> {
    constructor() {
        super("agency.hook.v1.ToolNameFilter", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_]*[a-z0-9]$" } } } },
            { no: 2, name: "location", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-z0-9][a-z0-9_-]*[a-z0-9])?$" } } } }
        ]);
    }
    create(value?: PartialMessage<ToolNameFilter>): ToolNameFilter {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.location = "";
        if (value !== undefined)
            reflectionMergePartial<ToolNameFilter>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ToolNameFilter): ToolNameFilter {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string location */ 2:
                    message.location = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ToolNameFilter, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string location = 2; */
        if (message.location !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.location);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.hook.v1.ToolNameFilter
 */
export const ToolNameFilter = new ToolNameFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ToolFilter$Type extends MessageType<ToolFilter> {
    constructor() {
        super("agency.hook.v1.ToolFilter", [
            { no: 1, name: "tools", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ToolNameFilter, options: { "buf.validate.field": { repeated: { maxItems: "100" } } } }
        ]);
    }
    create(value?: PartialMessage<ToolFilter>): ToolFilter {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tools = [];
        if (value !== undefined)
            reflectionMergePartial<ToolFilter>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ToolFilter): ToolFilter {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated agency.hook.v1.ToolNameFilter tools */ 1:
                    message.tools.push(ToolNameFilter.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ToolFilter, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated agency.hook.v1.ToolNameFilter tools = 1; */
        for (let i = 0; i < message.tools.length; i++)
            ToolNameFilter.internalBinaryWrite(message.tools[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.hook.v1.ToolFilter
 */
export const ToolFilter = new ToolFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SessionFilter$Type extends MessageType<SessionFilter> {
    constructor() {
        super("agency.hook.v1.SessionFilter", [
            { no: 1, name: "rbac", kind: "message", oneof: "predicate", T: () => RBACFilter },
            { no: 2, name: "tool", kind: "message", oneof: "predicate", T: () => ToolFilter }
        ]);
    }
    create(value?: PartialMessage<SessionFilter>): SessionFilter {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.predicate = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<SessionFilter>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SessionFilter): SessionFilter {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.hook.v1.RBACFilter rbac */ 1:
                    message.predicate = {
                        oneofKind: "rbac",
                        rbac: RBACFilter.internalBinaryRead(reader, reader.uint32(), options, (message.predicate as any).rbac)
                    };
                    break;
                case /* agency.hook.v1.ToolFilter tool */ 2:
                    message.predicate = {
                        oneofKind: "tool",
                        tool: ToolFilter.internalBinaryRead(reader, reader.uint32(), options, (message.predicate as any).tool)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SessionFilter, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.hook.v1.RBACFilter rbac = 1; */
        if (message.predicate.oneofKind === "rbac")
            RBACFilter.internalBinaryWrite(message.predicate.rbac, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* agency.hook.v1.ToolFilter tool = 2; */
        if (message.predicate.oneofKind === "tool")
            ToolFilter.internalBinaryWrite(message.predicate.tool, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.hook.v1.SessionFilter
 */
export const SessionFilter = new SessionFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HITLConfig$Type extends MessageType<HITLConfig> {
    constructor() {
        super("agency.hook.v1.HITLConfig", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "on_timeout_policy", kind: "enum", T: () => ["agency.hook.v1.HITLOnTimeoutPolicy", HITLOnTimeoutPolicy], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 4, name: "gating_scope", kind: "enum", T: () => ["agency.hook.v1.HITLGatingScope", HITLGatingScope], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 5, name: "timeout", kind: "message", T: () => Duration, options: { "buf.validate.field": { required: true } } },
            { no: 6, name: "steering_scope", kind: "enum", T: () => ["agency.hook.v1.HITLSteeringScope", HITLSteeringScope], options: { "buf.validate.field": { enum: { definedOnly: true } } } }
        ]);
    }
    create(value?: PartialMessage<HITLConfig>): HITLConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.enabled = false;
        message.onTimeoutPolicy = 0;
        message.gatingScope = 0;
        message.steeringScope = 0;
        if (value !== undefined)
            reflectionMergePartial<HITLConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: HITLConfig): HITLConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool enabled */ 1:
                    message.enabled = reader.bool();
                    break;
                case /* agency.hook.v1.HITLOnTimeoutPolicy on_timeout_policy */ 2:
                    message.onTimeoutPolicy = reader.int32();
                    break;
                case /* agency.hook.v1.HITLGatingScope gating_scope */ 4:
                    message.gatingScope = reader.int32();
                    break;
                case /* google.protobuf.Duration timeout */ 5:
                    message.timeout = Duration.internalBinaryRead(reader, reader.uint32(), options, message.timeout);
                    break;
                case /* agency.hook.v1.HITLSteeringScope steering_scope */ 6:
                    message.steeringScope = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: HITLConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool enabled = 1; */
        if (message.enabled !== false)
            writer.tag(1, WireType.Varint).bool(message.enabled);
        /* agency.hook.v1.HITLOnTimeoutPolicy on_timeout_policy = 2; */
        if (message.onTimeoutPolicy !== 0)
            writer.tag(2, WireType.Varint).int32(message.onTimeoutPolicy);
        /* agency.hook.v1.HITLGatingScope gating_scope = 4; */
        if (message.gatingScope !== 0)
            writer.tag(4, WireType.Varint).int32(message.gatingScope);
        /* google.protobuf.Duration timeout = 5; */
        if (message.timeout)
            Duration.internalBinaryWrite(message.timeout, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* agency.hook.v1.HITLSteeringScope steering_scope = 6; */
        if (message.steeringScope !== 0)
            writer.tag(6, WireType.Varint).int32(message.steeringScope);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.hook.v1.HITLConfig
 */
export const HITLConfig = new HITLConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HookConfig$Type extends MessageType<HookConfig> {
    constructor() {
        super("agency.hook.v1.HookConfig", [
            { no: 1, name: "hook_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } },
            { no: 3, name: "priority", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "timeout_policy", kind: "enum", T: () => ["agency.hook.v1.HookTimeoutPolicy", HookTimeoutPolicy, "HOOK_TIMEOUT_POLICY_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 7, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "tenant_filter", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "100", items: { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } } } },
            { no: 9, name: "workspace_filter", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "100", items: { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } } } },
            { no: 10, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "1024" } } } },
            { no: 11, name: "subject", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "512" } } } },
            { no: 12, name: "timeout", kind: "message", T: () => Duration },
            { no: 13, name: "delivery_mode", kind: "enum", T: () => ["agency.hook.v1.HookDeliveryMode", HookDeliveryMode, "HOOK_DELIVERY_MODE_"], options: { "buf.validate.field": { enum: { definedOnly: true } } } },
            { no: 14, name: "session_filters", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SessionFilter, options: { "buf.validate.field": { repeated: { maxItems: "10" } } } },
            { no: 15, name: "hitl_config", kind: "message", T: () => HITLConfig },
            { no: 16, name: "points", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["agency.hook.v1.HookPoint", HookPoint, "HOOK_POINT_"], options: { "buf.validate.field": { repeated: { minItems: "1", maxItems: "17", items: { enum: { definedOnly: true, notIn: [0] } } } } } },
            { no: 17, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128" } } } },
            { no: 18, name: "location", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } }
        ]);
    }
    create(value?: PartialMessage<HookConfig>): HookConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.hookName = "";
        message.priority = 0;
        message.timeoutPolicy = 0;
        message.enabled = false;
        message.tenantFilter = [];
        message.workspaceFilter = [];
        message.description = "";
        message.subject = "";
        message.deliveryMode = 0;
        message.sessionFilters = [];
        message.points = [];
        message.name = "";
        message.location = "";
        if (value !== undefined)
            reflectionMergePartial<HookConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: HookConfig): HookConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string hook_name */ 1:
                    message.hookName = reader.string();
                    break;
                case /* int32 priority */ 3:
                    message.priority = reader.int32();
                    break;
                case /* agency.hook.v1.HookTimeoutPolicy timeout_policy */ 4:
                    message.timeoutPolicy = reader.int32();
                    break;
                case /* bool enabled */ 7:
                    message.enabled = reader.bool();
                    break;
                case /* repeated string tenant_filter */ 8:
                    message.tenantFilter.push(reader.string());
                    break;
                case /* repeated string workspace_filter */ 9:
                    message.workspaceFilter.push(reader.string());
                    break;
                case /* string description */ 10:
                    message.description = reader.string();
                    break;
                case /* string subject */ 11:
                    message.subject = reader.string();
                    break;
                case /* google.protobuf.Duration timeout */ 12:
                    message.timeout = Duration.internalBinaryRead(reader, reader.uint32(), options, message.timeout);
                    break;
                case /* agency.hook.v1.HookDeliveryMode delivery_mode */ 13:
                    message.deliveryMode = reader.int32();
                    break;
                case /* repeated agency.hook.v1.SessionFilter session_filters */ 14:
                    message.sessionFilters.push(SessionFilter.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* agency.hook.v1.HITLConfig hitl_config */ 15:
                    message.hitlConfig = HITLConfig.internalBinaryRead(reader, reader.uint32(), options, message.hitlConfig);
                    break;
                case /* repeated agency.hook.v1.HookPoint points */ 16:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.points.push(reader.int32());
                    else
                        message.points.push(reader.int32());
                    break;
                case /* string name */ 17:
                    message.name = reader.string();
                    break;
                case /* string location */ 18:
                    message.location = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: HookConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string hook_name = 1; */
        if (message.hookName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.hookName);
        /* int32 priority = 3; */
        if (message.priority !== 0)
            writer.tag(3, WireType.Varint).int32(message.priority);
        /* agency.hook.v1.HookTimeoutPolicy timeout_policy = 4; */
        if (message.timeoutPolicy !== 0)
            writer.tag(4, WireType.Varint).int32(message.timeoutPolicy);
        /* bool enabled = 7; */
        if (message.enabled !== false)
            writer.tag(7, WireType.Varint).bool(message.enabled);
        /* repeated string tenant_filter = 8; */
        for (let i = 0; i < message.tenantFilter.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.tenantFilter[i]);
        /* repeated string workspace_filter = 9; */
        for (let i = 0; i < message.workspaceFilter.length; i++)
            writer.tag(9, WireType.LengthDelimited).string(message.workspaceFilter[i]);
        /* string description = 10; */
        if (message.description !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.description);
        /* string subject = 11; */
        if (message.subject !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.subject);
        /* google.protobuf.Duration timeout = 12; */
        if (message.timeout)
            Duration.internalBinaryWrite(message.timeout, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* agency.hook.v1.HookDeliveryMode delivery_mode = 13; */
        if (message.deliveryMode !== 0)
            writer.tag(13, WireType.Varint).int32(message.deliveryMode);
        /* repeated agency.hook.v1.SessionFilter session_filters = 14; */
        for (let i = 0; i < message.sessionFilters.length; i++)
            SessionFilter.internalBinaryWrite(message.sessionFilters[i], writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* agency.hook.v1.HITLConfig hitl_config = 15; */
        if (message.hitlConfig)
            HITLConfig.internalBinaryWrite(message.hitlConfig, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* repeated agency.hook.v1.HookPoint points = 16; */
        if (message.points.length) {
            writer.tag(16, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.points.length; i++)
                writer.int32(message.points[i]);
            writer.join();
        }
        /* string name = 17; */
        if (message.name !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.name);
        /* string location = 18; */
        if (message.location !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.location);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.hook.v1.HookConfig
 */
export const HookConfig = new HookConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HookTimeoutEvent$Type extends MessageType<HookTimeoutEvent> {
    constructor() {
        super("agency.hook.v1.HookTimeoutEvent", [
            { no: 1, name: "hook_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "point", kind: "enum", T: () => ["agency.hook.v1.HookPoint", HookPoint, "HOOK_POINT_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 3, name: "timeout_policy", kind: "enum", T: () => ["agency.hook.v1.HookTimeoutPolicy", HookTimeoutPolicy, "HOOK_TIMEOUT_POLICY_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 4, name: "timeout_duration_ms", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } },
            { no: 5, name: "occurred_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 6, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 7, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 8, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } }
        ]);
    }
    create(value?: PartialMessage<HookTimeoutEvent>): HookTimeoutEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.hookName = "";
        message.point = 0;
        message.timeoutPolicy = 0;
        message.timeoutDurationMs = 0n;
        message.tenant = "";
        message.workspace = "";
        message.sessionId = "";
        if (value !== undefined)
            reflectionMergePartial<HookTimeoutEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: HookTimeoutEvent): HookTimeoutEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string hook_name */ 1:
                    message.hookName = reader.string();
                    break;
                case /* agency.hook.v1.HookPoint point */ 2:
                    message.point = reader.int32();
                    break;
                case /* agency.hook.v1.HookTimeoutPolicy timeout_policy */ 3:
                    message.timeoutPolicy = reader.int32();
                    break;
                case /* int64 timeout_duration_ms */ 4:
                    message.timeoutDurationMs = reader.int64().toBigInt();
                    break;
                case /* google.protobuf.Timestamp occurred_at */ 5:
                    message.occurredAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.occurredAt);
                    break;
                case /* string tenant */ 6:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 7:
                    message.workspace = reader.string();
                    break;
                case /* string session_id */ 8:
                    message.sessionId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: HookTimeoutEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string hook_name = 1; */
        if (message.hookName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.hookName);
        /* agency.hook.v1.HookPoint point = 2; */
        if (message.point !== 0)
            writer.tag(2, WireType.Varint).int32(message.point);
        /* agency.hook.v1.HookTimeoutPolicy timeout_policy = 3; */
        if (message.timeoutPolicy !== 0)
            writer.tag(3, WireType.Varint).int32(message.timeoutPolicy);
        /* int64 timeout_duration_ms = 4; */
        if (message.timeoutDurationMs !== 0n)
            writer.tag(4, WireType.Varint).int64(message.timeoutDurationMs);
        /* google.protobuf.Timestamp occurred_at = 5; */
        if (message.occurredAt)
            Timestamp.internalBinaryWrite(message.occurredAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string tenant = 6; */
        if (message.tenant !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 7; */
        if (message.workspace !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.workspace);
        /* string session_id = 8; */
        if (message.sessionId !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.sessionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.hook.v1.HookTimeoutEvent
 */
export const HookTimeoutEvent = new HookTimeoutEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HookErrorEvent$Type extends MessageType<HookErrorEvent> {
    constructor() {
        super("agency.hook.v1.HookErrorEvent", [
            { no: 1, name: "hook_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "point", kind: "enum", T: () => ["agency.hook.v1.HookPoint", HookPoint, "HOOK_POINT_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 3, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "4096" } } } },
            { no: 4, name: "stack_trace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "16384" } } } },
            { no: 5, name: "occurred_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 6, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 7, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 8, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 9, name: "panic_recovered", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<HookErrorEvent>): HookErrorEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.hookName = "";
        message.point = 0;
        message.errorMessage = "";
        message.stackTrace = "";
        message.tenant = "";
        message.workspace = "";
        message.sessionId = "";
        message.panicRecovered = false;
        if (value !== undefined)
            reflectionMergePartial<HookErrorEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: HookErrorEvent): HookErrorEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string hook_name */ 1:
                    message.hookName = reader.string();
                    break;
                case /* agency.hook.v1.HookPoint point */ 2:
                    message.point = reader.int32();
                    break;
                case /* string error_message */ 3:
                    message.errorMessage = reader.string();
                    break;
                case /* string stack_trace */ 4:
                    message.stackTrace = reader.string();
                    break;
                case /* google.protobuf.Timestamp occurred_at */ 5:
                    message.occurredAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.occurredAt);
                    break;
                case /* string tenant */ 6:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 7:
                    message.workspace = reader.string();
                    break;
                case /* string session_id */ 8:
                    message.sessionId = reader.string();
                    break;
                case /* bool panic_recovered */ 9:
                    message.panicRecovered = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: HookErrorEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string hook_name = 1; */
        if (message.hookName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.hookName);
        /* agency.hook.v1.HookPoint point = 2; */
        if (message.point !== 0)
            writer.tag(2, WireType.Varint).int32(message.point);
        /* string error_message = 3; */
        if (message.errorMessage !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.errorMessage);
        /* string stack_trace = 4; */
        if (message.stackTrace !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.stackTrace);
        /* google.protobuf.Timestamp occurred_at = 5; */
        if (message.occurredAt)
            Timestamp.internalBinaryWrite(message.occurredAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string tenant = 6; */
        if (message.tenant !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 7; */
        if (message.workspace !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.workspace);
        /* string session_id = 8; */
        if (message.sessionId !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.sessionId);
        /* bool panic_recovered = 9; */
        if (message.panicRecovered !== false)
            writer.tag(9, WireType.Varint).bool(message.panicRecovered);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.hook.v1.HookErrorEvent
 */
export const HookErrorEvent = new HookErrorEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SanitizationRule$Type extends MessageType<SanitizationRule> {
    constructor() {
        super("agency.hook.v1.SanitizationRule", [
            { no: 1, name: "rule_type", kind: "enum", T: () => ["agency.hook.v1.SanitizationRuleType", SanitizationRuleType, "SANITIZATION_RULE_TYPE_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 2, name: "field_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 3, name: "pattern", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "2048" } } } },
            { no: 4, name: "allowed_values", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "1000", items: { string: { maxLen: "4096" } } } } } },
            { no: 5, name: "denied_values", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "1000", items: { string: { maxLen: "4096" } } } } } },
            { no: 6, name: "max_length", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 7, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "512" } } } },
            { no: 9, name: "severity", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "16", pattern: "^(INFO|WARN|ERROR|CRITICAL)$" } } } }
        ]);
    }
    create(value?: PartialMessage<SanitizationRule>): SanitizationRule {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.ruleType = 0;
        message.fieldPath = "";
        message.pattern = "";
        message.allowedValues = [];
        message.deniedValues = [];
        message.maxLength = 0;
        message.enabled = false;
        message.description = "";
        message.severity = "";
        if (value !== undefined)
            reflectionMergePartial<SanitizationRule>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SanitizationRule): SanitizationRule {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.hook.v1.SanitizationRuleType rule_type */ 1:
                    message.ruleType = reader.int32();
                    break;
                case /* string field_path */ 2:
                    message.fieldPath = reader.string();
                    break;
                case /* string pattern */ 3:
                    message.pattern = reader.string();
                    break;
                case /* repeated string allowed_values */ 4:
                    message.allowedValues.push(reader.string());
                    break;
                case /* repeated string denied_values */ 5:
                    message.deniedValues.push(reader.string());
                    break;
                case /* int32 max_length */ 6:
                    message.maxLength = reader.int32();
                    break;
                case /* bool enabled */ 7:
                    message.enabled = reader.bool();
                    break;
                case /* string description */ 8:
                    message.description = reader.string();
                    break;
                case /* string severity */ 9:
                    message.severity = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SanitizationRule, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.hook.v1.SanitizationRuleType rule_type = 1; */
        if (message.ruleType !== 0)
            writer.tag(1, WireType.Varint).int32(message.ruleType);
        /* string field_path = 2; */
        if (message.fieldPath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.fieldPath);
        /* string pattern = 3; */
        if (message.pattern !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pattern);
        /* repeated string allowed_values = 4; */
        for (let i = 0; i < message.allowedValues.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.allowedValues[i]);
        /* repeated string denied_values = 5; */
        for (let i = 0; i < message.deniedValues.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.deniedValues[i]);
        /* int32 max_length = 6; */
        if (message.maxLength !== 0)
            writer.tag(6, WireType.Varint).int32(message.maxLength);
        /* bool enabled = 7; */
        if (message.enabled !== false)
            writer.tag(7, WireType.Varint).bool(message.enabled);
        /* string description = 8; */
        if (message.description !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.description);
        /* string severity = 9; */
        if (message.severity !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.severity);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.hook.v1.SanitizationRule
 */
export const SanitizationRule = new SanitizationRule$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ToolSanitizationConfig$Type extends MessageType<ToolSanitizationConfig> {
    constructor() {
        super("agency.hook.v1.ToolSanitizationConfig", [
            { no: 1, name: "tool_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-z0-9][a-z0-9_]*[a-z0-9])?$" } } } },
            { no: 2, name: "input_rules", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SanitizationRule, options: { "buf.validate.field": { repeated: { maxItems: "50" } } } },
            { no: 3, name: "output_rules", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SanitizationRule, options: { "buf.validate.field": { repeated: { maxItems: "50" } } } },
            { no: 4, name: "abort_on_violation", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "log_violations", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "tenant_scope", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 8, name: "workspace_scope", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } }
        ]);
    }
    create(value?: PartialMessage<ToolSanitizationConfig>): ToolSanitizationConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.toolName = "";
        message.inputRules = [];
        message.outputRules = [];
        message.abortOnViolation = false;
        message.logViolations = false;
        message.enabled = false;
        message.tenantScope = "";
        message.workspaceScope = "";
        if (value !== undefined)
            reflectionMergePartial<ToolSanitizationConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ToolSanitizationConfig): ToolSanitizationConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tool_name */ 1:
                    message.toolName = reader.string();
                    break;
                case /* repeated agency.hook.v1.SanitizationRule input_rules */ 2:
                    message.inputRules.push(SanitizationRule.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated agency.hook.v1.SanitizationRule output_rules */ 3:
                    message.outputRules.push(SanitizationRule.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool abort_on_violation */ 4:
                    message.abortOnViolation = reader.bool();
                    break;
                case /* bool log_violations */ 5:
                    message.logViolations = reader.bool();
                    break;
                case /* bool enabled */ 6:
                    message.enabled = reader.bool();
                    break;
                case /* string tenant_scope */ 7:
                    message.tenantScope = reader.string();
                    break;
                case /* string workspace_scope */ 8:
                    message.workspaceScope = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ToolSanitizationConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tool_name = 1; */
        if (message.toolName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.toolName);
        /* repeated agency.hook.v1.SanitizationRule input_rules = 2; */
        for (let i = 0; i < message.inputRules.length; i++)
            SanitizationRule.internalBinaryWrite(message.inputRules[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated agency.hook.v1.SanitizationRule output_rules = 3; */
        for (let i = 0; i < message.outputRules.length; i++)
            SanitizationRule.internalBinaryWrite(message.outputRules[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* bool abort_on_violation = 4; */
        if (message.abortOnViolation !== false)
            writer.tag(4, WireType.Varint).bool(message.abortOnViolation);
        /* bool log_violations = 5; */
        if (message.logViolations !== false)
            writer.tag(5, WireType.Varint).bool(message.logViolations);
        /* bool enabled = 6; */
        if (message.enabled !== false)
            writer.tag(6, WireType.Varint).bool(message.enabled);
        /* string tenant_scope = 7; */
        if (message.tenantScope !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.tenantScope);
        /* string workspace_scope = 8; */
        if (message.workspaceScope !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.workspaceScope);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.hook.v1.ToolSanitizationConfig
 */
export const ToolSanitizationConfig = new ToolSanitizationConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HookRegistrationRequest$Type extends MessageType<HookRegistrationRequest> {
    constructor() {
        super("agency.hook.v1.HookRegistrationRequest", [
            { no: 1, name: "config", kind: "message", T: () => HookConfig, options: { "buf.validate.field": { required: true } } },
            { no: 2, name: "handler_endpoint", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 3, name: "handler_type", kind: "enum", T: () => ["agency.hook.v1.HookHandlerType", HookHandlerType, "HOOK_HANDLER_TYPE_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 4, name: "registered_by", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } }
        ]);
    }
    create(value?: PartialMessage<HookRegistrationRequest>): HookRegistrationRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.handlerEndpoint = "";
        message.handlerType = 0;
        message.registeredBy = "";
        if (value !== undefined)
            reflectionMergePartial<HookRegistrationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: HookRegistrationRequest): HookRegistrationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.hook.v1.HookConfig config */ 1:
                    message.config = HookConfig.internalBinaryRead(reader, reader.uint32(), options, message.config);
                    break;
                case /* string handler_endpoint */ 2:
                    message.handlerEndpoint = reader.string();
                    break;
                case /* agency.hook.v1.HookHandlerType handler_type */ 3:
                    message.handlerType = reader.int32();
                    break;
                case /* string registered_by */ 4:
                    message.registeredBy = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: HookRegistrationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.hook.v1.HookConfig config = 1; */
        if (message.config)
            HookConfig.internalBinaryWrite(message.config, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string handler_endpoint = 2; */
        if (message.handlerEndpoint !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.handlerEndpoint);
        /* agency.hook.v1.HookHandlerType handler_type = 3; */
        if (message.handlerType !== 0)
            writer.tag(3, WireType.Varint).int32(message.handlerType);
        /* string registered_by = 4; */
        if (message.registeredBy !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.registeredBy);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.hook.v1.HookRegistrationRequest
 */
export const HookRegistrationRequest = new HookRegistrationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HookRegistrationResponse$Type extends MessageType<HookRegistrationResponse> {
    constructor() {
        super("agency.hook.v1.HookRegistrationResponse", [
            { no: 1, name: "hook_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "registered_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 3, name: "handler_endpoint", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "512" } } } }
        ]);
    }
    create(value?: PartialMessage<HookRegistrationResponse>): HookRegistrationResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.hookName = "";
        message.handlerEndpoint = "";
        if (value !== undefined)
            reflectionMergePartial<HookRegistrationResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: HookRegistrationResponse): HookRegistrationResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string hook_name */ 1:
                    message.hookName = reader.string();
                    break;
                case /* google.protobuf.Timestamp registered_at */ 2:
                    message.registeredAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.registeredAt);
                    break;
                case /* string handler_endpoint */ 3:
                    message.handlerEndpoint = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: HookRegistrationResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string hook_name = 1; */
        if (message.hookName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.hookName);
        /* google.protobuf.Timestamp registered_at = 2; */
        if (message.registeredAt)
            Timestamp.internalBinaryWrite(message.registeredAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string handler_endpoint = 3; */
        if (message.handlerEndpoint !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.handlerEndpoint);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.hook.v1.HookRegistrationResponse
 */
export const HookRegistrationResponse = new HookRegistrationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HookDeregistrationRequest$Type extends MessageType<HookDeregistrationRequest> {
    constructor() {
        super("agency.hook.v1.HookDeregistrationRequest", [
            { no: 1, name: "hook_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<HookDeregistrationRequest>): HookDeregistrationRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.hookName = "";
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial<HookDeregistrationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: HookDeregistrationRequest): HookDeregistrationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string hook_name */ 1:
                    message.hookName = reader.string();
                    break;
                case /* string reason */ 2:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: HookDeregistrationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string hook_name = 1; */
        if (message.hookName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.hookName);
        /* string reason = 2; */
        if (message.reason !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.hook.v1.HookDeregistrationRequest
 */
export const HookDeregistrationRequest = new HookDeregistrationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HookDeregistrationResponse$Type extends MessageType<HookDeregistrationResponse> {
    constructor() {
        super("agency.hook.v1.HookDeregistrationResponse", [
            { no: 1, name: "hook_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "deregistered_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<HookDeregistrationResponse>): HookDeregistrationResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.hookName = "";
        if (value !== undefined)
            reflectionMergePartial<HookDeregistrationResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: HookDeregistrationResponse): HookDeregistrationResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string hook_name */ 1:
                    message.hookName = reader.string();
                    break;
                case /* google.protobuf.Timestamp deregistered_at */ 2:
                    message.deregisteredAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deregisteredAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: HookDeregistrationResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string hook_name = 1; */
        if (message.hookName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.hookName);
        /* google.protobuf.Timestamp deregistered_at = 2; */
        if (message.deregisteredAt)
            Timestamp.internalBinaryWrite(message.deregisteredAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.hook.v1.HookDeregistrationResponse
 */
export const HookDeregistrationResponse = new HookDeregistrationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HookListRequest$Type extends MessageType<HookListRequest> {
    constructor() {
        super("agency.hook.v1.HookListRequest", [
            { no: 1, name: "point", kind: "enum", T: () => ["agency.hook.v1.HookPoint", HookPoint, "HOOK_POINT_"], options: { "buf.validate.field": { enum: { definedOnly: true } } } },
            { no: 2, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 3, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 4, name: "enabled_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<HookListRequest>): HookListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.point = 0;
        message.tenant = "";
        message.workspace = "";
        message.enabledOnly = false;
        if (value !== undefined)
            reflectionMergePartial<HookListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: HookListRequest): HookListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.hook.v1.HookPoint point */ 1:
                    message.point = reader.int32();
                    break;
                case /* string tenant */ 2:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 3:
                    message.workspace = reader.string();
                    break;
                case /* bool enabled_only */ 4:
                    message.enabledOnly = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: HookListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.hook.v1.HookPoint point = 1; */
        if (message.point !== 0)
            writer.tag(1, WireType.Varint).int32(message.point);
        /* string tenant = 2; */
        if (message.tenant !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 3; */
        if (message.workspace !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.workspace);
        /* bool enabled_only = 4; */
        if (message.enabledOnly !== false)
            writer.tag(4, WireType.Varint).bool(message.enabledOnly);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.hook.v1.HookListRequest
 */
export const HookListRequest = new HookListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HookListResponse$Type extends MessageType<HookListResponse> {
    constructor() {
        super("agency.hook.v1.HookListResponse", [
            { no: 1, name: "hooks", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => HookConfig },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } }
        ]);
    }
    create(value?: PartialMessage<HookListResponse>): HookListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.hooks = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial<HookListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: HookListResponse): HookListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated agency.hook.v1.HookConfig hooks */ 1:
                    message.hooks.push(HookConfig.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: HookListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated agency.hook.v1.HookConfig hooks = 1; */
        for (let i = 0; i < message.hooks.length; i++)
            HookConfig.internalBinaryWrite(message.hooks[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.hook.v1.HookListResponse
 */
export const HookListResponse = new HookListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HITLRequestEvent$Type extends MessageType<HITLRequestEvent> {
    constructor() {
        super("agency.hook.v1.HITLRequestEvent", [
            { no: 1, name: "hook_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "point", kind: "enum", T: () => ["agency.hook.v1.HookPoint", HookPoint, "HOOK_POINT_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 3, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 4, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 5, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 6, name: "user_sub", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 7, name: "payload", kind: "message", T: () => Any, options: { "buf.validate.field": { required: true } } },
            { no: 8, name: "gating_scope", kind: "enum", T: () => ["agency.hook.v1.HITLGatingScope", HITLGatingScope], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 9, name: "requested_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 10, name: "timeout", kind: "message", T: () => Duration, options: { "buf.validate.field": { required: true } } },
            { no: 11, name: "hitl_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 12, name: "deadline", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 13, name: "on_timeout_policy", kind: "enum", T: () => ["agency.hook.v1.HITLOnTimeoutPolicy", HITLOnTimeoutPolicy], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } }
        ]);
    }
    create(value?: PartialMessage<HITLRequestEvent>): HITLRequestEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.hookName = "";
        message.point = 0;
        message.tenant = "";
        message.workspace = "";
        message.sessionId = "";
        message.userSub = "";
        message.gatingScope = 0;
        message.hitlId = "";
        message.onTimeoutPolicy = 0;
        if (value !== undefined)
            reflectionMergePartial<HITLRequestEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: HITLRequestEvent): HITLRequestEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string hook_name */ 1:
                    message.hookName = reader.string();
                    break;
                case /* agency.hook.v1.HookPoint point */ 2:
                    message.point = reader.int32();
                    break;
                case /* string tenant */ 3:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 4:
                    message.workspace = reader.string();
                    break;
                case /* string session_id */ 5:
                    message.sessionId = reader.string();
                    break;
                case /* string user_sub */ 6:
                    message.userSub = reader.string();
                    break;
                case /* google.protobuf.Any payload */ 7:
                    message.payload = Any.internalBinaryRead(reader, reader.uint32(), options, message.payload);
                    break;
                case /* agency.hook.v1.HITLGatingScope gating_scope */ 8:
                    message.gatingScope = reader.int32();
                    break;
                case /* google.protobuf.Timestamp requested_at */ 9:
                    message.requestedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.requestedAt);
                    break;
                case /* google.protobuf.Duration timeout */ 10:
                    message.timeout = Duration.internalBinaryRead(reader, reader.uint32(), options, message.timeout);
                    break;
                case /* string hitl_id */ 11:
                    message.hitlId = reader.string();
                    break;
                case /* google.protobuf.Timestamp deadline */ 12:
                    message.deadline = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deadline);
                    break;
                case /* agency.hook.v1.HITLOnTimeoutPolicy on_timeout_policy */ 13:
                    message.onTimeoutPolicy = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: HITLRequestEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string hook_name = 1; */
        if (message.hookName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.hookName);
        /* agency.hook.v1.HookPoint point = 2; */
        if (message.point !== 0)
            writer.tag(2, WireType.Varint).int32(message.point);
        /* string tenant = 3; */
        if (message.tenant !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 4; */
        if (message.workspace !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.workspace);
        /* string session_id = 5; */
        if (message.sessionId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.sessionId);
        /* string user_sub = 6; */
        if (message.userSub !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.userSub);
        /* google.protobuf.Any payload = 7; */
        if (message.payload)
            Any.internalBinaryWrite(message.payload, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* agency.hook.v1.HITLGatingScope gating_scope = 8; */
        if (message.gatingScope !== 0)
            writer.tag(8, WireType.Varint).int32(message.gatingScope);
        /* google.protobuf.Timestamp requested_at = 9; */
        if (message.requestedAt)
            Timestamp.internalBinaryWrite(message.requestedAt, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Duration timeout = 10; */
        if (message.timeout)
            Duration.internalBinaryWrite(message.timeout, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* string hitl_id = 11; */
        if (message.hitlId !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.hitlId);
        /* google.protobuf.Timestamp deadline = 12; */
        if (message.deadline)
            Timestamp.internalBinaryWrite(message.deadline, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* agency.hook.v1.HITLOnTimeoutPolicy on_timeout_policy = 13; */
        if (message.onTimeoutPolicy !== 0)
            writer.tag(13, WireType.Varint).int32(message.onTimeoutPolicy);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.hook.v1.HITLRequestEvent
 */
export const HITLRequestEvent = new HITLRequestEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HITLResponseEvent$Type extends MessageType<HITLResponseEvent> {
    constructor() {
        super("agency.hook.v1.HITLResponseEvent", [
            { no: 1, name: "hook_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "outcome", kind: "enum", T: () => ["agency.hook.v1.HITLOutcome", HITLOutcome], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 4, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "2048" } } } },
            { no: 5, name: "steering", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "4096" } } } },
            { no: 8, name: "replacement_args", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "65536" } } } },
            { no: 9, name: "hitl_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 6, name: "approver_sub", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 7, name: "responded_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<HITLResponseEvent>): HITLResponseEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.hookName = "";
        message.sessionId = "";
        message.outcome = 0;
        message.reason = "";
        message.steering = "";
        message.replacementArgs = "";
        message.hitlId = "";
        message.approverSub = "";
        if (value !== undefined)
            reflectionMergePartial<HITLResponseEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: HITLResponseEvent): HITLResponseEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string hook_name */ 1:
                    message.hookName = reader.string();
                    break;
                case /* string session_id */ 2:
                    message.sessionId = reader.string();
                    break;
                case /* agency.hook.v1.HITLOutcome outcome */ 3:
                    message.outcome = reader.int32();
                    break;
                case /* string reason */ 4:
                    message.reason = reader.string();
                    break;
                case /* string steering */ 5:
                    message.steering = reader.string();
                    break;
                case /* string replacement_args */ 8:
                    message.replacementArgs = reader.string();
                    break;
                case /* string hitl_id */ 9:
                    message.hitlId = reader.string();
                    break;
                case /* string approver_sub */ 6:
                    message.approverSub = reader.string();
                    break;
                case /* google.protobuf.Timestamp responded_at */ 7:
                    message.respondedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.respondedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: HITLResponseEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string hook_name = 1; */
        if (message.hookName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.hookName);
        /* string session_id = 2; */
        if (message.sessionId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.sessionId);
        /* agency.hook.v1.HITLOutcome outcome = 3; */
        if (message.outcome !== 0)
            writer.tag(3, WireType.Varint).int32(message.outcome);
        /* string reason = 4; */
        if (message.reason !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.reason);
        /* string steering = 5; */
        if (message.steering !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.steering);
        /* string approver_sub = 6; */
        if (message.approverSub !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.approverSub);
        /* google.protobuf.Timestamp responded_at = 7; */
        if (message.respondedAt)
            Timestamp.internalBinaryWrite(message.respondedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string replacement_args = 8; */
        if (message.replacementArgs !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.replacementArgs);
        /* string hitl_id = 9; */
        if (message.hitlId !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.hitlId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.hook.v1.HITLResponseEvent
 */
export const HITLResponseEvent = new HITLResponseEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HookRegistrationAck$Type extends MessageType<HookRegistrationAck> {
    constructor() {
        super("agency.hook.v1.HookRegistrationAck", [
            { no: 1, name: "heartbeat_interval_seconds", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 300, gte: 5 } } } },
            { no: 2, name: "dispatch_subject", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "512" } } } }
        ]);
    }
    create(value?: PartialMessage<HookRegistrationAck>): HookRegistrationAck {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.heartbeatIntervalSeconds = 0;
        message.dispatchSubject = "";
        if (value !== undefined)
            reflectionMergePartial<HookRegistrationAck>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: HookRegistrationAck): HookRegistrationAck {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 heartbeat_interval_seconds */ 1:
                    message.heartbeatIntervalSeconds = reader.int32();
                    break;
                case /* string dispatch_subject */ 2:
                    message.dispatchSubject = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: HookRegistrationAck, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 heartbeat_interval_seconds = 1; */
        if (message.heartbeatIntervalSeconds !== 0)
            writer.tag(1, WireType.Varint).int32(message.heartbeatIntervalSeconds);
        /* string dispatch_subject = 2; */
        if (message.dispatchSubject !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.dispatchSubject);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.hook.v1.HookRegistrationAck
 */
export const HookRegistrationAck = new HookRegistrationAck$Type();
